import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ExcelService} from '../../../service/excel.service';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {
    Country, CreateCheckListAccessGQL,
    GetCountriesGQL,
    GetCountriesQuery,
    GetUnitiesByCountryGQL,
    GetUnitiesByCountryQuery,
    RemoveCheckListAccessGQL,
    SearchCheckListAccess,
    SearchCheckListAccessGQL, SearchCheckListAccessQuery,
    SearchCheckListAccessResult,
    Unity, User
} from '../../../../generated/graphql';
import {BaseComponent} from '../../../base/base.component';
import {QueryRef} from 'apollo-angular';
import {UserService} from "../../../service/user.service";
import moment from "moment";
import {FilterService} from "../../../service/filter.service";

declare var $: any;

@Component({
    selector: 'app-access-control-home',
    templateUrl: './access-control-home.component.html',
    styleUrls: ['./access-control-home.component.scss']
})
export class AccessControlHomeComponent extends BaseComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild('start') start: ElementRef;
    filterKey = 'access_control_filter';

    user = new User();
    unityId: string;
    unities: Array<Unity>;
    unityQuery: QueryRef<GetUnitiesByCountryQuery>;

    countries: Array<Country>;
    countryQuery: QueryRef<GetCountriesQuery>;

    filterUnities: Array<Unity>;
    filterCountries: Array<Country>;
    filterUnityId: string;
    filterCountryId: string;

    selectedCountryId: string;
    selectedUnityId: string;

    // novos campos
    filter: SearchCheckListAccess = new SearchCheckListAccess();

    checklistResult: SearchCheckListAccessResult = new SearchCheckListAccessResult();
    checklistQuery: QueryRef<SearchCheckListAccessQuery>;

    labelCountry: boolean;
    labelUnity: boolean;
    exportExcel: boolean;
    actionNew: boolean;
    actionUpdate: boolean;
    viewDashboard: boolean;

    constructor(public router: Router,
                public activatedRoute: ActivatedRoute,
                public translate: TranslateService,
                private getUnitiesByCountryGQL: GetUnitiesByCountryGQL,
                private getCountriesGQL: GetCountriesGQL,
                public searchChecklistGQL: SearchCheckListAccessGQL,
                public removeChecklistGQL: RemoveCheckListAccessGQL,
                public createChecklistGQL: CreateCheckListAccessGQL,
                public userService: UserService,
                public excelService: ExcelService,
                private filterService: FilterService
                ) {
        super(router, translate);
    }

    ngAfterViewInit(): void {
        this.userService.user.subscribe({
            next: data => {
                this.user = data as User;
            }, error: err => super.onError(err)
        });
        this.actionUserProfileBTN();
        if (this.actionUserProfile() === false) {
            this.filter.unityId = this.user.unity.id;
        }

        const savedFilter: SearchCheckListAccess = this.filterService.getFilter(this.filterKey);

        if (savedFilter) {
            console.log('SAVED FILTER', savedFilter);

            this.filter = {
                responsible: savedFilter.responsible || '',
                start: savedFilter.start || moment().utcOffset(0, true).startOf('day').format(),
                end: savedFilter.end || moment().utcOffset(0, true).endOf('day').format(),
                countryId: savedFilter.countryId,
                unityId: savedFilter.unityId
            };

            console.log('FILTER', this.filter);

            this.filterCountryId = savedFilter.countryId || null;
            this.filterUnityId = savedFilter.unityId || null;

            if (savedFilter.countryId) {
                console.log('SAVED FILTER UNITY', savedFilter.countryId);
                this.getUnitiesFilter();

                this.filter.unityId = savedFilter.unityId;
            }

        }

        this.getQueryString();

        this.setDatePickerRange('js-daterangepicker', (start, end, label) => {
            this.filter.start = start.utcOffset(0, true).format();
            this.filter.end = end.utcOffset(0, true).format();
        }, this.filter.start, this.filter.end);
        if (this.actionUserProfile() === false) {
            this.filter.unityId = this.user.unity.id;
        }

        console.log('FILTER ANTES DA LISTA', this.filter);

        this.actionList();

    }

    ngOnDestroy(): void {
    }

    ngOnInit(): void {
        this.getCountries();
        this.getUnities();
    }

    actionCreate() {
        super.confirmMessage(this.translate.instant('atencao'), this.translate.instant('criarchecklist'), () => {
            this.createChecklistGQL.mutate().subscribe(dt => {
                this.router.navigate([`access-control/create/${dt.data.createCheckListAccess.id}`]);
            });
        });
    }

    actionList() {
        this.checklistQuery = this.searchChecklistGQL.watch({data: this.filter});
        this.checklistQuery.valueChanges.subscribe(({data}) => {
            this.checklistResult = data.searchCheckListAccess as SearchCheckListAccessResult;
            this.setQueryString();
        });
    }

    getCountries() {
        this.countryQuery = this.getCountriesGQL.watch();
        this.countryQuery.valueChanges.subscribe(({data}) => {
            this.filterCountries = data.countries as Array<Country>;
        });
    }

    getUnities() {
        this.unityQuery = this.getUnitiesByCountryGQL.watch(
            {countryId: this.isNullOrUndefined(this.selectedCountryId) ? '' : this.selectedCountryId});
        this.unityQuery.valueChanges.subscribe(({data}) => {
            this.unities = data.getUnitiesByCountry as Array<Unity>;
        });
    }

    actionFilter() {
        if (this.actionUserProfile() === false) {
            this.filterUnityId = this.user.unity.id;
        }

        console.log('UNITY ID NO FILTER', this.filter.unityId);
        console.log('UNITY ID ALONE', this.filterUnityId);

        this.filter.unityId = this.filterUnityId;
        this.filter.countryId = this.filterCountryId;
        this.checklistQuery.refetch({data: this.filter}).then(() => {
            this.setQueryString();
        });

        this.filterService.setFilter(this.filterKey, this.filter);
    }

    actionEdit(id: string) {
        this.router.navigate([`access-control/create/${id}`]);
    }

    actionDelete(id: string) {
        super.confirmMessage(this.translate.instant('atencao'), this.translate.instant('excluirchecklist'), () => {
            this.removeChecklistGQL.mutate({id: id}).subscribe((result) => {
                super.showMessage(this.translate.instant('success'), this.translate.instant('checklistdeletada'), 'success');
                this.actionFilter();
            });
        });
    }

    getUnitiesFilter() {
        // this.filterUnityId = null;
        this.unityQuery = this.getUnitiesByCountryGQL.watch(
            {countryId: this.isNullOrUndefined(this.filterCountryId || this.filter.countryId) ? '' : this.filterCountryId});
        this.unityQuery.valueChanges.subscribe(({data}) => {
            this.filterUnities = data.getUnitiesByCountry as Array<Unity>;
        });
    }

    actionExcel() {
        this.excelService.getExcelAccessControl(this.filter).subscribe({
            next: data => {
                this.downloadHandlerFile(data);
            }, error: err => super.onError(err)
        });
    }

    pageChanged(event) {
        this.filter.page = event;
        this.actionFilter();
    }

    actionUserProfile() {
        switch (this.user.profile) {
            case 'admin':
                return true;
            case 'local-manager':
                return false;
            case 'user':
                return false;
            case 'vigilant-leader':
                return false;
            case 'vigilant-conductor':
                return false;
            case 'vigilant':
                return false;
            case 'lecturer':
                return false;
            case 'corporate-operator':
                return true;
            case 'local-operator':
                return false;
        }
    }

    actionUserProfileBTN() {
        // Dashboard visível só p/ admin e local-manager (default false cobre os demais).
        this.viewDashboard = false;
        switch (this.user.profile) {
            case 'admin':
                this.viewDashboard = true;
                this.labelCountry = true;
                this.labelUnity = true;
                this.exportExcel = true;
                this.actionNew = true;
                this.actionUpdate = true;
                break;
            case 'local-manager':
                this.viewDashboard = true;
                this.labelCountry = false;
                this.labelUnity = false;
                this.exportExcel = true;
                this.actionNew = false;
                this.actionUpdate = false;
                break;
            case 'user':
                this.labelCountry = false;
                this.labelUnity = false;
                this.exportExcel = false;
                this.actionNew = false;
                this.actionUpdate = false;
                break;
            case 'vigilant-leader':
                this.labelCountry = false;
                this.labelUnity = false;
                this.exportExcel = false;
                this.actionNew = false;
                this.actionUpdate = false;
                break;
            case 'vigilant-conductor':
                this.labelCountry = false;
                this.labelUnity = false;
                this.exportExcel = false;
                this.actionNew = false;
                this.actionUpdate = false;
                break;
            case 'vigilant':
                this.labelCountry = false;
                this.labelUnity = false;
                this.exportExcel = false;
                this.actionNew = false;
                this.actionUpdate = false;
                break;
            case 'lecturer':
                this.labelCountry = false;
                this.labelUnity = false;
                this.exportExcel = false;
                this.actionNew = false;
                this.actionUpdate = false;
                break;
            case 'corporate-operator':
                this.labelCountry = true;
                this.labelUnity = true;
                this.exportExcel = true;
                this.actionNew = true;
                this.actionUpdate = true;
                break;
            case 'local-operator':
                this.labelCountry = false;
                this.labelUnity = false;
                this.exportExcel = true;
                this.actionNew = true;
                this.actionUpdate = true;
                break;
        }
    }

    getQueryString() {
        this.activatedRoute.queryParams.subscribe((params) => {
            this.filter.start = params.start.replace('Z', '');
            this.filter.end = params.end.replace('Z', '');
        });
    }

    setQueryString() {
        this.router.navigate([], {
            relativeTo: this.activatedRoute,
            queryParams: {start: this.filter.start || null, end: this.filter.end || null}, // Remove o parâmetro se vazio
            queryParamsHandling: 'merge', // Mantém outros query params
        });
    }

    clearFilter() {
        this.filterService.clearFilter(this.filterKey);
        this.filter = {
            responsible: '',
            start: moment().utcOffset(0, true).startOf('day').format(),
            end: moment().utcOffset(0, true).endOf('day').format(),
            page: 1
        };
        this.filterUnityId = null;
        this.filterCountryId = null;

        this.actionFilter();
    }
}
